





























import Vue from 'vue'
import { FileModelExtended } from '@/types/common'
import style from './style.module.scss'

import textInput from '@/components/controls/text-input/text-input.vue'

export default Vue.extend({
name: 'file-list',
  components: {
    textInput
  },
  props: {
    list: Array as () => FileModelExtended[],
    images: Boolean,
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      s: style
    }
  },
  methods: {
    blur(event: Event, file: FileModelExtended) {
      const target = event.target as HTMLInputElement
      target.blur();

      file.Edit = false;
    }
  }
})
